// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__N7raf","title":"AfterBackImages_title__1slA8","images":"AfterBackImages_images__2w_9-"};